var map = {
	"./MBudget.svg": 1246,
	"./Mtel.svg": 1158,
	"./Quickline.svg": 1215,
	"./Salt.svg": 1212,
	"./Spusu.svg": 1159,
	"./Swisscom.svg": 1152,
	"./TalkTalk.svg": 1216,
	"./Wingo.svg": 1211,
	"./migros.svg": 1214,
	"./yallo.svg": 1213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1245;